import { Injectable } from '@angular/core';
import { AttributeInfoDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { Observable, ReplaySubject } from 'rxjs';
import { NativeLayer } from '../models/native-layer';
import { DateRange } from '@common-modules/shared/model/date/date-range';

@Injectable({ providedIn: 'root' })
export class GenericMapDataService {
  private _propertiesByLayer = new Map<string, { [key: string]: any }>();
  private _formattedPropertiesByLayer = new Map<string, { [key: string]: string }>();
  private _labelPropertiesByLayer = new Map<string, { [key: string]: AttributeInfoDto }>();
  private _currentTimeStep$ = new ReplaySubject<Date>(1);
  private _currenDateRange$ = new ReplaySubject<DateRange>(1);

  setProperties(
    innerLayer: NativeLayer,
    properties: { [key: string]: any },
    getLayerId: (innerLayer: NativeLayer) => string,
  ): void {
    const layerId = getLayerId(innerLayer);
    if (layerId) {
      this._propertiesByLayer.set(layerId, properties);
    }
  }

  getProperties(
    innerLayer: NativeLayer,
    getLayerId: (innerLayer: NativeLayer) => string,
  ): { [key: string]: any } | undefined {
    const layerId = getLayerId(innerLayer);
    if (layerId) {
      return this._propertiesByLayer.get(layerId) ?? {};
    }
  }

  setFormattedProperties(
    innerLayer: NativeLayer,
    formattedProperties: { [key: string]: string },
    getLayerId: (innerLayer: NativeLayer) => string,
  ): void {
    const layerId = getLayerId(innerLayer);
    if (layerId) {
      this._formattedPropertiesByLayer.set(layerId, formattedProperties);
    }
  }

  getFormattedProperties(
    innerLayer: NativeLayer,
    getLayerId: (innerLayer: NativeLayer) => string,
  ): { [key: string]: string } | undefined {
    const layerId = getLayerId(innerLayer);
    if (layerId) {
      return this._formattedPropertiesByLayer.get(layerId) ?? {};
    }
  }

  setLabelProperties(
    innerLayer: NativeLayer,
    formattedProperties: { [key: string]: AttributeInfoDto },
    getLayerId: (innerLayer: NativeLayer) => string,
  ): void {
    const layerId = getLayerId(innerLayer);
    if (layerId) {
      this._labelPropertiesByLayer.set(layerId, formattedProperties);
    }
  }

  getLabelProperties(
    innerLayer: NativeLayer,
    getLayerId: (innerLayer: NativeLayer) => string,
  ): { [key: string]: AttributeInfoDto } | undefined {
    const layerId = getLayerId(innerLayer);
    if (layerId) {
      return this._labelPropertiesByLayer.get(layerId) ?? {};
    }
  }

  setCurrentTimeStep(step: Date) {
    this._currentTimeStep$.next(step);
  }

  setCurrentDateRange(dateRange: DateRange){
    this._currenDateRange$.next(dateRange);
  }

  listenCurrentTimeStep$(): Observable<Date> {
    return this._currentTimeStep$.asObservable();
  }

  listenCurrentDateRange$(): Observable<DateRange>{
    return this._currenDateRange$.asObservable();
  }
}
